export const planRouteNames = {
    dashboard: "/",
    kanban: "/kanban",
    forms: "/forms",
    products: "/products",
    leads: "/leads",
    tags: "/tags",
    prompt: ["/prompts", "suggestions"],
    "quick-messages": "quick-messages",
    schedules: "/schedules",
    queueIntegration: "/queue-integration",
    audios: "/audios",
    automation: "/dm-automations",
    chats: "/chats",
}

export const invoicesStatusMap = {
    paid: "Pago",
    waiting: "Aguardando",
    waitingPayment: "Aguardando pagamento",
    waiting_approval: "Aguardando aprovação",
    canceled: "Cancelado",
    pending: "Pendente",
}
